module.exports = __webpack_public_path__ + "static/media/blenkinsopp.a4f82217.jpg";